export default __webpack_public_path__ + "static/simple-bubble-3f63d169086a5d2a3aa1a78dd36fde21.png";